---
title: About Research & Development
cover_image: /images/article/fabio-oyXis2kALVg-unsplash.jpg
description: "研究・開発のこと"
---

## 何研究してるの？

インターネット等を活用した情報収集の自動化、データの可視化、機械学習関連技術について、研究・開発しています。

## 進捗はどうですか？

知見は貯まるが成果は微々たるもの……。

研究・開発をもっといろいろな方面で進めようと思って法人化していますが、いまいち有効活用できていません。

## 目標は？

楽して暮らしたい。

<br>
<br>
<br>

----
<small><span>Photo by <a href="https://unsplash.com/@fabioha?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">fabio</a> on <a href="https://unsplash.com/s/photos/ai?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Unsplash</a></span></small>